
import sharedStyles from 'styles/css/SharedStyles.module.scss';
// import styles from 'styles/css/Main.module.scss';
// import drawerStyles from 'styles/css/Drawer.module.scss';
// import actionStyles from 'styles/css/ActionStyles.module.scss';
// import Logo from 'styles/images/logo/logo512.png';

import ShortHeaderWithBackBtnNameOfGod from 'components/root/partials/header/ShortHeaderWithBackBtnNameOfGod';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';

const Activities = () => {

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtnNameOfGod />

                

                <div className={[formStyles.title, formStyles['text-center'], sharedStyles['text-red']].join(' ')}>
                    فیلدهای فعالیت Dr20
                </div>
                

                <p className={[ruleStyles['text-justify'], sharedStyles.flex, sharedStyles['flex-col'], sharedStyles['text-primary']].join(' ')}>
                    ۱ -آموزش بهداشت و سلامت
                    <br />
                    <span className={[sharedStyles['w-full'] ,sharedStyles['text-left'], sharedStyles['dir-ltr']].join(' ')}>(Education of Preventive Diseases)</span>
                </p>
                <p className={[ruleStyles['text-justify'], sharedStyles.flex, sharedStyles['flex-col'], sharedStyles['text-primary']].join(' ')}>
                    ۲-مشاوره پزشکی و صدور نسخه الکترونیک:
                    <br />
                    <span className={[sharedStyles['w-full'] ,sharedStyles['text-left'], sharedStyles['dir-ltr']].join(' ')}>(Medical Consultation and Electronic Prescription)</span>
                </p>
                <p className={[ruleStyles['text-justify'], sharedStyles.flex, sharedStyles['flex-col'], sharedStyles['text-primary']].join(' ')}>
                    ۳-توریسم درمانی سازمان یافته و حرفه ای:
                    <br />
                    <span className={[sharedStyles['w-full'] ,sharedStyles['text-left'], sharedStyles['dir-ltr']].join(' ')}>(Organized and Professional Medical Tourism)</span>
                </p>
                <p className={[ruleStyles['text-justify'], sharedStyles.flex, sharedStyles['flex-col'], sharedStyles['text-primary']].join(' ')}>
                    ۴-شاپینگ سنتر: 
                    <br />
                    <span className={[sharedStyles['w-full'] ,sharedStyles['text-left'], sharedStyles['dir-ltr']].join(' ')}>(Shopping Center)</span>
                    <span className={[sharedStyles['w-full']].join(' ')}>داروهای مجاز گیاهی و تجهیزات پزشکی برند</span>
                </p>
                



                <div className={[formStyles.title, formStyles['text-center'], sharedStyles['text-red']].join(' ')}>
                    هدف پروژه دکتر بیست (Dr20) :
                </div>
                <p className={ruleStyles['text-justify']}>
                    خداوند سبحان، در سوره مبارکه ضحی، آیه شریفه ۴ میفرماید:
                    <br />
                    "وللآخره خیر لک من الاولی"
                    <br />
                    "وقطعا سرای آخرت، برای تو از دنیا، نیکوتر خواهد بود"..
                    <br />
                </p>
                <p className={ruleStyles['text-justify']}>
                    استاد بیان، سعدی شیرین سخن هم چنین سروده است:
                    <br />
                    <div className={[sharedStyles.flex, sharedStyles.justifyBetween].join(' ')}>
                        <span>نام نیکو گربماند زآدمی</span>
                        <span>به کزو ماند سرای زرنگار</span>
                    </div>
                </p>
                
            </div>
                
        </div>

    );
}

export default Activities;